<a routerLinkActive  #rla="routerLinkActive" [routerLink]="routerLink" aria-label="Cliquer sur le lien">
  <span class="font-theme-source text-base md:text-lg text-white px-3 py-1 cursor-pointer hover:underline active:underline font-bold">{{text}}</span>
</a>
